import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";

const getAccessor = (col) =>
  typeof col.accessor === "string"
    ? col.accessor
    : col.accessorKey || col.id;

const prepareData = (columns, rows) => {
  const validColumns = columns.filter(
    (col) => getAccessor(col) && col.accessor !== "actions"
  );

  return rows.map((row) => {
    const obj = {};
    validColumns.forEach((col) => {
      const key = getAccessor(col);
      const header = col.Header || col.header || key;

      const value = row?.[key];
      obj[header] = value === null || value === undefined ? "" : value;
    });
    return obj;
  });
};

/* ================= CSV ================= */

export const exportToCSV = (columns, rows, filename = "export") => {
  if (!rows?.length) return;

  const formattedData = prepareData(columns, rows);
  const csv = Papa.unparse(formattedData);

  const blob = new Blob([csv], {
    type: "text/csv;charset=utf-8;",
  });

  saveAs(blob, `${filename}.csv`);
};

/* ================= EXCEL ================= */

export const exportToExcel = (columns, rows, filename) => {
  const filteredColumns = columns.filter(
    col => col.accessor && col.accessor !== "actions"
  );

  const excelData = rows.map(row =>
    filteredColumns.reduce((acc, col) => {
      let value = "";

      if (typeof col.accessor === "function") {
        value = col.accessor(row);
      } else {
        value = row[col.accessor];
      }

      acc[col.Header] = value ?? "";
      return acc;
    }, {})
  );

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Leave Requests");

  XLSX.writeFile(workbook, `${filename}.xlsx`);
};

/* ================= PDF ================= */

export const exportToPDF = (columns, rows, filename = "export") => {
  if (!rows?.length) return;

  const doc = new jsPDF();
  const data = prepareData(columns, rows);

  const headers = Object.keys(data[0]);
  const body = data.map((row) => Object.values(row));

  doc.autoTable({
    head: [headers],
    body,
    startY: 20,
  });

  doc.save(`${filename}.pdf`);
};
